import styled from 'styled-components';
import { maxDevice } from '~/styles/breakpoints';
// import map from '~/assets/images/map.svg';
import background from '~/assets/images/5.jpg';

export const Container = styled.div`
    min-height: 100vh;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-direction: column;
`;

export const Image = styled.img`
    position: absolute;
    top: 200px;
    left: 50%;
    transform: translate(-50%, 0);
    z-index: 1;

    width: 100%;
    max-width: 430px;
    height: auto;

    transition: all 0.2s linear;

    &.active {
        transform: translate(0, 0);
        top: 54px;
        left: 40px;
        height: 60px;
        width: auto;
    }

    @media ${maxDevice.laptop} {
        margin-bottom: 30px !important;
        transform: translate(0, 0);
        top: 54px;
        left: 40px;
        height: 60px;
        width: auto;
    }
`;

export const InputsContainer = styled.div``;

export const SubmitButton = styled.button`
    width: 51px;
    height: 51px;

    border: 0;
    background: transparent;

    svg {
        font-size: 3.9rem;
        color: #fff;
    }
    transition: all 0.2s linear;
`;

export const Form = styled.form`
    position: relative;
    z-index: 1;

    display: flex;
    align-items: flex-start;
    justify-content: center;
    flex-direction: column;

    width: 100%;
    max-width: 600px;

    height: 400px;

    .inputs-container {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;

        width: 100%;
    }

    transition: all 0.2s linear;

    &.active {
        align-items: flex-start;
        justify-content: flex-end;

        padding-bottom: 60px;

        max-width: 100%;

        height: 332px;

        div,
        ul {
            box-sizing: border-box;
            margin: 0 15px;
        }
        ul {
            margin-top: 10px;
        }

        .inputs-container {
            flex-direction: row;
            align-items: flex-end;
            margin: 0;
        }

        input {
            line-height: 40px;
            font-size: 2.6rem;
        }

        ${SubmitButton} {
            height: 40;
            width: 40;
        }
    }

    @media ${maxDevice.laptop} {
        &.active > .inputs-container {
            flex-direction: column;
        }
    }
`;

export const CodesList = styled.ul`
    display: flex;
    align-items: flex-start;
    flex-wrap: wrap;
    margin-top: 15px;

    > li {
        display: flex;
        align-items: center;
        justify-content: space-between;
        border: 1px solid #03a9f4;
        color: #03a9f4;
        border-radius: 16px;

        cursor: pointer;

        margin-right: 5px;
        margin-top: 5px;

        transition: all 0.2s linear;

        .button-label {
            padding: 2px 15px;
            padding-right: 10px;
            border: 0;
            background: none;
            color: #03a9f4;
            font-weight: 700;
        }

        .code-remove {
            display: flex;
            align-items: center;
            justify-content: center;

            height: auto;
            width: auto;

            padding: 0;
            border: 0;
            background: none;

            font-weight: 700;
            font-size: 1.7rem;
            color: #03a9f4;

            margin: 0 5px;
        }

        &:hover {
            color: #fff;
            background-color: #03a9f4;

            button {
                color: #fff;
            }
        }
    }
`;

export const TrackingContainer = styled.div`
    flex: 1;
    position: relative;

    width: 100%;
    padding: 30px;

    display: ${props => (props.tracking ? 'block' : 'flex')};
    align-items: center;
    justify-content: center;
    flex-direction: column;

    background-image: url(${background});
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    background-attachment: fixed;

    overflow: hidden;

    &::before {
        content: '';
        position: absolute;
        top: 0;
        bottom: 0;
        right: 0;
        left: 0;

        background: linear-gradient(
            to right,
            rgb(9, 19, 23),
            rgb(21, 37, 43),
            rgb(29, 52, 62)
        );

        opacity: 0.9;
    }

    transition: all 0.2s linear;

    &.active {
        height: 332px;
        border-bottom-left-radius: 15px;
        border-bottom-right-radius: 15px;
        box-shadow: -1px 2px 60px 0px rgba(0, 0, 0, 0.3);
    }
`;
